import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createSlots as _createSlots, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-617d86a6")

_pushScopeId("data-v-617d86a6")
const _hoisted_1 = { class: "pt-6 pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col mt-3"
}
const _hoisted_3 = { class: "w-full mb-2 px-4 py-3 font-montserrat text-12px text-gray-lp-300 rounded-lg bg-gray-lp-1000 text-left" }
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_EditAddress = _resolveComponent("EditAddress")!
  const _component_ModalBookingReverseJourney = _resolveComponent("ModalBookingReverseJourney")!
  const _component_ModalBookingReverseJourneyV4 = _resolveComponent("ModalBookingReverseJourneyV4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.props.isShow)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.confirmValue.title,
          message: _ctx.confirmValue.message,
          image: "warning",
          isDisabled: _ctx.isDisabledButtonBatalkan,
          textSuccess: _ctx.confirmValue.textSuccess,
          textCancel: _ctx.confirmValue.textCancel,
          class: "px-8 detail-z-index",
          "custom-width": "405px",
          onClose: _ctx.confirmationCancel,
          onSubmit: _ctx.confirmationSubmit
        }, {
          custom: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_Select, {
                class: "w-full text-left",
                isDefaultBlack: "",
                isShowDefault: false,
                dataSelect: _ctx.rejectedReasons,
                value: 
            _ctx.isRejectedStatus ? _ctx.detailDataStt.refundRemarks : _ctx.selectedReasonValue
          ,
                isDisabled: _ctx.isRejectedStatus,
                isOpenMenu: _ctx.openSelect,
                onOpenSelect: () => (_ctx.openSelect = true),
                onCloseSelect: () => (_ctx.openSelect = false),
                onChooseSelect: _ctx.onSelectStatus
              }, null, 8, ["dataSelect", "value", "isDisabled", "isOpenMenu", "onOpenSelect", "onCloseSelect", "onChooseSelect"]),
              (_ctx.isShowInputNewStt)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.confirmValue.messageInputNewStt), 1),
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.sttNo,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNo = $event)),
                        _ctx.onInputSttNo
                      ],
                      errorIcon: false,
                      errorCaption: _ctx.error.captionError,
                      showMaxLength: false,
                      maxLength: 17,
                      error: _ctx.error.sttNo,
                      onBlur: _ctx.onBlurSttNo,
                      onChange: _ctx.onChangeSttNo
                    }, null, 8, ["modelValue", "errorCaption", "error", "onUpdate:modelValue", "onBlur", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isReasonAbleToGenerateNewStt)
                ? (_openBlock(), _createBlock(_component_CheckboxV2, {
                    key: 1,
                    class: "pt-3 text-13px",
                    label: _ctx.$t('Buat STT baru untuk pengembalian paket'),
                    labelWeight: "regular",
                    value: _ctx.isGenerateNewStt,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.isGenerateNewStt = $event))
                  }, null, 8, ["label", "value"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "message", "isDisabled", "textSuccess", "textCancel", "onClose", "onSubmit"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: !_ctx.isDetail ? _ctx.directFinish : _ctx.closeModalSuccess,
      title: _ctx.titleFinish,
      message: _ctx.messageFinish,
      image: "image-modal-success",
      textSuccess: _ctx.successFinish,
      textCancel: _ctx.isGenerateNewStt ? 'OK' : '',
      onClose: !_ctx.isDetail ? _ctx.directFinish : _ctx.closeModalSuccess,
      class: "px-8"
    }, _createSlots({ _: 2 }, [
      (_ctx.isGenerateNewStt)
        ? {
            name: "custom-button",
            fn: _withId(() => [
              _createVNode(_component_lp_button, _mergeProps(_ctx.customStyleButtonNewStt, {
                icon: 
          _ctx.$refs['op-success']?.visible
            ? `chevron-up-white`
            : `chevron-down-white`
        ,
                onClick: _ctx.togglePanelPrintSuccess
              }), null, 16, ["icon", "onClick"]),
              _createVNode(_component_OverlayPanel, {
                ref: "op-success",
                appendTo: "body",
                style: {"width":"auto"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customStyleButtonNewStt.groupOptions, (option, groupIndex) => {
                    return (_openBlock(), _createBlock(_Fragment, {
                      key: option.label
                    }, [
                      _createVNode(_component_LpButton, {
                        onClick: 
              () => {
                option.clickFunction();
                _ctx.$refs['op-success'].hide();
              }
            ,
                        class: "w-auto",
                        flat: "",
                        dense: "",
                        iconLeft: option.icon,
                        title: option.label
                      }, null, 8, ["onClick", "iconLeft", "title"]),
                      (groupIndex < _ctx.customStyleButtonNewStt.groupOptions.length - 1)
                        ? (_openBlock(), _createBlock("hr", _hoisted_4))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 512)
            ])
          }
        : undefined
    ]), 1032, ["onSubmit", "title", "message", "textSuccess", "textCancel", "onClose"]), [
      [_vShow, _ctx.confirmationFinish]
    ]),
    (_ctx.editAddress)
      ? (_openBlock(), _createBlock(_component_EditAddress, {
          key: 1,
          defaultStt: _ctx.formEditAddress,
          posField: true,
          onClose: _ctx.closeEditAddress,
          onOnSubmit: _ctx.cancelBookingWithGenerateStt
        }, null, 8, ["defaultStt", "onClose", "onOnSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.editAddressReverseJourney)
      ? (_openBlock(), _createBlock(_component_ModalBookingReverseJourney, {
          key: 2,
          defaultStt: _ctx.formEditAddress,
          onClose: _ctx.closeEditAddressReverseJourney,
          rtsOrCnx: _ctx.isRtsOrCnx,
          onOnSubmit: _ctx.cancelBookingWithGenerateStt
        }, null, 8, ["defaultStt", "onClose", "rtsOrCnx", "onOnSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBookingReverseJourneyV4, {
      modelValue: _ctx.editAddressReverseJourneyV4,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editAddressReverseJourneyV4 = $event)),
      form: _ctx.formEditAddress,
      rtsOrCnx: _ctx.isRtsOrCnx,
      onOnSubmit: _ctx.cancelBookingWithGenerateStt
    }, null, 8, ["modelValue", "form", "rtsOrCnx", "onOnSubmit"])
  ], 64))
})